<template>
  <router-view />
</template>

<script>
export default {
  name: "app-supplier"
};
</script>

<style lang="scss" scoped></style>
